import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'osn-cxb-display-service-type-icon-control',
  templateUrl: './display-service-type-icon-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DisplayServiceTypeIconControlComponent),
      multi: true,
    },
  ],
})
export class DisplayServiceTypeIconControlComponent implements ControlValueAccessor {
  public label = 'Display service type icon';

  public value = false;
  public isDisabled = false;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public onChange: Function = () => {};
  public onTouch: Function = () => {};

  public writeValue(value: boolean): void {
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  public registerOnChange(onChangeFunction: Function): void {
    this.onChange = onChangeFunction;
  }

  public registerOnTouched(onTouchFunction: Function): void {
    this.onTouch = onTouchFunction;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }

  public onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.value = checkbox.checked;
    this.onChange(this.value);
    this.onTouch();
  }
}
